import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from '@mui/material';
import { theme } from './Style';
import { AppContent } from './AppContent';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        {/* <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
          <App />
        </PersistGate> */}
        <App />
      </Provider>
    </ThemeProvider>
  </>
);

reportWebVitals();
